export default {
	create: {
		successMessage: 'New limit product has been created.',
	},
	delete: {
		successMessage: 'Remove limit product success',
	},
};
